import type { JSX } from 'react'
import type { ILabelProps } from 'atoms/Label'
import type { ILabelGroupProps } from '../LabelGroup'

import { DolbyAtmosLabelIcon } from 'atoms/Icon/Templates'
import {
  LabelInlineSecondaryTemplateSmBold,
  QualityLabel,
} from 'atoms/Label/Templates'
import {
  isQualityResolutionToken,
  normalizeQualityToken,
} from 'atoms/Label/Templates/qualityBadgeProps'
import { FIXED_INDENTS } from 'vars/index'
import { LabelGroup } from '../LabelGroup'

export interface ILabelGroupTemplate6Props extends Omit<
  ILabelGroupProps,
  'children'
> {
  list?: ILabelProps['title'][] | null
}

export const LabelGroupTemplate6 = ({
  list,
  columnGap = FIXED_INDENTS.INDENT_40,
  rowGap = FIXED_INDENTS.INDENT_30,
  quality,
  dolbyAtmos,
  ...rest
}: ILabelGroupTemplate6Props): JSX.Element => {
  const qualityToken = quality ? normalizeQualityToken(quality) : null
  const labels =
    list?.filter(
      (item) =>
        item &&
        !(
          qualityToken &&
          isQualityResolutionToken(item) &&
          normalizeQualityToken(item) === qualityToken
        )
    ) ?? []

  const hasContent = labels.length > 0 || quality || dolbyAtmos

  return hasContent ? (
    <LabelGroup columnGap={columnGap} rowGap={rowGap} wrap {...rest}>
      {labels.map((title, i) =>
        isQualityResolutionToken(title) ? (
          <QualityLabel key={`${i}${title}`} title={title} />
        ) : (
          <LabelInlineSecondaryTemplateSmBold
            key={`${i}${title}`}
            title={title}
          />
        )
      )}
      {quality && <QualityLabel title={quality} />}
      {dolbyAtmos && <DolbyAtmosLabelIcon />}
    </LabelGroup>
  ) : (
    <></>
  )
}
